import './chapter_list_component.scss'

import { Controller } from 'stimulus'

const OFFSET = 80

export default class extends Controller {
  scrollListener () {
    if (this.scrolledPastChapterListTop) {
      this.listInfoController.stickToTop()
    } else if (this.scrolledPastChapterListBottom) {
      this.listInfoController.stickToBottom()
    } else {
      this.listInfoController.resetPosition()
    }
  }

  get listInfoController () {
    return this.application.controllers.find(controller => {
      return controller.context.identifier === 'list-info'
    })
  }

  get listInfoHeight () {
    return this.listInfoController.height
  }

  get elementRect () {
    return this.element.getBoundingClientRect()
  }

  get scrolledPastChapterListTop () {
    return this.elementRect.top <= OFFSET && (this.elementRect.bottom - this.listInfoHeight - OFFSET) >= OFFSET
  }

  get scrolledPastChapterListBottom () {
    return (this.elementRect.bottom - this.listInfoHeight - OFFSET) < OFFSET
  }
}
